import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center font-Avenir text-center color-[#2c3e50] m-16" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"font-semibold text-2xl\"> 👋 Welcome to the simple mapcreate tool </div><div class=\"flex flex-col items-center\"><div class=\"w-3 h-3 rounded-full border-red-300 border\"></div><div class=\"h-9 border-l border-red-300\"></div><div class=\"w-3 h-3 rounded-full border-red-300 border\"></div></div><div class=\"font-medium text-base text-gray-500\"> This tool can create, edit and allow you to easily download maps... </div>", 3)




export default /*#__PURE__*/_defineComponent({
  emits: ["createMap"],
  setup(__props, { emit }: { emit: ({
  (e: 'createMap'): void
}), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "border-2 border-red-300 py-2 px-6 mt-7 hover:bg-red-50",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('createMap')))
      }, "Create")
    ])
  ]))
}
}

})